import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20digital%20media%20landscape%20with%20abstract%20breaking%20news%20vibe%2C%20deep%20crimson%20red%20gradient%20overlay%2C%20cyberpunk%20inspired%20atmosphere%2C%20dynamic%20light%20streaks%20in%20darkness%2C%20editorial%20newsroom%20tension%2C%20professional%20cinematic%20composition%20with%20depth%20of%20field%2C%20dark%20red%20and%20charcoal%20black%20palette&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
        alt="17吃瓜 - 全网热点追踪，网红塌房实录，24h独家爆料"
        title="17吃瓜品牌主页 - 网红黑料实时更新平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/90 via-background-950/70 to-background-950/30"></div>

      <div className="relative z-10 container-page h-full flex items-center">
        <div className="w-full">
          <div className="max-w-2xl">
            <p className="text-primary-400 text-xs md:text-sm font-medium tracking-widest mb-4">
              全网热点追踪
            </p>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-foreground-50 leading-tight mb-6">
              网红塌房实录
              <br />
              24h独家爆料
            </h1>
            <p className="text-foreground-300 text-sm md:text-base leading-relaxed mb-8 max-w-lg">
              聚合17吃瓜网、17吃瓜爆料、17吃瓜黑料等最全吃瓜入口，
              实时更新网红黑料、塌房现场与每日大瓜事件
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/category/wanghong-heiliao"
                className="bg-primary-500 text-foreground-50 font-semibold rounded-full px-6 py-3 whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-primary-400 text-sm md:text-base"
              >
                立即吃瓜
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <Link
                to="/about"
                className="border border-foreground-400 text-foreground-100 font-medium rounded-full px-6 py-3 whitespace-nowrap cursor-pointer transition-all duration-300 hover:border-foreground-200 hover:text-foreground-50 text-sm md:text-base"
              >
                我要爆料
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 right-6 md:bottom-10 md:right-10 z-10 flex items-center gap-3">
        <div className="flex items-center gap-2 bg-background-950/60 backdrop-blur-sm rounded-full px-4 py-2">
          <span className="w-2 h-2 bg-primary-500 rounded-full animate-pulse"></span>
          <span className="text-foreground-300 text-xs">实时更新中</span>
        </div>
      </div>
    </section>
  );
}